'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STANDARD_CACHE = exports.STANDARD_CACHE = 'i18n-cached-standard-locales';
var PUBLIC_CACHE = exports.PUBLIC_CACHE = 'i18n-cached-public-locales';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.520/js/init/internal/localeCacheKeys.js
// module id = 134
// module chunks = 177 178